import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import NavbarModulo from '../../components/NavbarModulo';

import {
    renderField,
    SelectField,
    AsyncSelectField
} from "../../Utils/renderField/renderField";

function DistribuidorForm(props) {
    const { registroDistribuidor, crear, modulo,
        modificarDistribuidor, listaCentros, lectura,
        listarCuentasContables, obtenerPaises
    } = props;
    
    const editar = window.location.href.includes('editar');
    let titulo = editar ? 'Modificar distribuidor' : 'Crear distribuidor';
    let disabled = false;
    if (crear === false && editar === false) {
        disabled = true;
        titulo = 'Ver distribuidor';
    }
    let autoFocus = true;
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    
    return (
        <div>
            <NavbarModulo
                modulo={modulo}
                titulo={titulo}
            />
            <br />
            <div className="mb-4 card card-small text-white bg-dark mb-3">
                <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                    <div className="d-flex flex-column flex-1 mx-4">
                        <div className='mb-2 row'>
                            <div className='row'>
                                <div className='col-6'>
                                    <Field
                                        autoFocus={autoFocus}
                                        name="nombre"
                                        placeholder="Nombre"
                                        className="form-control"
                                        component={renderField}
                                        disabled={disabled}
                                        msj="Nombre"
                                    />
                                </div>
                                <div className='col-3'>
                                    {obtenerPaises &&
                                        <div className="form-floating">
                                            <Field
                                                name="pais"
                                                options={obtenerPaises}
                                                crear={crear}
                                                dato={crear === true ? 0 : lectura.pais}
                                                component={SelectField}
                                                className="form-select"
                                                disabled={disabled}
                                                msj="Pais"
                                            />
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className='col-8 mt-2'>
                                <Field
                                    name="direccion"
                                    placeholder="Dirección"
                                    className="form-control"
                                    component={renderField}
                                    disabled={disabled}
                                    msj="Dirección"
                                />
                            </div>
                        </div>
                        {crear === true &&
                            <div className='mb-2 row'>
                                <div className='col-4'>
                                    <Field
                                        name="centro_costo"
                                        placeholder="Centro costo"
                                        className="form-control-find"
                                        component={SelectField}
                                        options={listaCentros}
                                        msj="Centro costo"
                                    />
                                </div> 
                                <div className='col-8'>
                                    <Field
                                        name="cuenta"
                                        placeholder="Cuenta contable..."
                                        className="form-control-find"
                                        component={AsyncSelectField}
                                        loadOptions={listarCuentasContables}
                                        msj="Cuenta contable"
                                    />
                                </div> 
                            </div>
                        }
                        {crear === false && editar === false &&
                            <div className='mb-2 row'>
                                <div className='col-4'>
                                    <Field
                                        name="centro_costo"
                                        placeholder="Centro costo"
                                        className="form-control-find"
                                        component={SelectField}
                                        disabled={disabled}
                                        dato={lectura.centro_costo}
                                        options={listaCentros}
                                        msj="Centro costo"
                                    />
                                </div>
                                <div className='col-8'>
                                    <Field
                                        name="nombre_cuenta"
                                        placeholder="Cuenta contable"
                                        className="form-control"
                                        component={renderField}
                                        disabled={disabled}
                                        msj="Cuenta contable"
                                    />
                                </div> 
                            </div>
                        }
                        {crear === false && editar === true &&
                            <div>
                                <div className='mb-2 row'>
                                    <div className='col-4'>
                                        <Field
                                            name="centro_costo_mod"
                                            placeholder="Centro costo"
                                            className="form-control-find"
                                            component={SelectField}
                                            dato={lectura.centro_costo}
                                            options={listaCentros}
                                            msj="Centro costo"
                                        />
                                    </div>
                                    <div className='col-8'>
                                        <Field
                                            name="nombre_cuenta"
                                            placeholder="Linea promocional"
                                            className="form-control"
                                            component={renderField}
                                            disabled={disabled}
                                            msj="Cuenta contable"
                                        />
                                    </div>
                                </div>
                                <div className='mb-2 row'>
                                    <div className='col-4'>
                                    </div>
                                    <div className='col-8'>
                                        <Field
                                            name="cuenta_mod"
                                            placeholder="Cuenta contable..."
                                            className="form-control-find"
                                            component={AsyncSelectField}
                                            loadOptions={listarCuentasContables}
                                            msj="Cuenta contable"
                                        />
                                    </div> 
                                </div>
                            </div>

                        }
                        <div className='d-flex flex-row mt-3'>
                            {crear === true && editar === false &&
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    type='submit'
                                    onClick={registroDistribuidor}
                                >
                                    Guardar
                                </button>
                            }
                            {crear === false && editar === true &&
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    type='submit'
                                    onClick={modificarDistribuidor}
                                >
                                    Modificar
                                </button>
                            }
                            <a
                                href={`/#/visitador_medico/${id_emp[5]}/distribuidor`}
                                className='btn btn-secondary mb-3'
                            >
                                Regresar
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

DistribuidorForm.propTypes = {
    crear: PropTypes.bool,
    lectura: PropTypes.object,
    modulo: PropTypes.object,
};

export default reduxForm({
    form: 'FormDistribuidorVM',
    
})(DistribuidorForm);


